import React from 'react';
import Link from 'gatsby-link'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types'; // ES6
import Nav from './Nav';

class Footer extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {

      const { location, children } = this.props;
        return (
            <footer id="footer" style={this.props.timeout ? {display: 'none'} : {}}>
                <Nav  location={this.props.location} />
            </footer>
        )
    }
}

Footer.propTypes = {
    timeout: PropTypes.bool,
    location: PropTypes.object
}
export default connect()(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.js